module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity/brag/brag-06-5c101d7001e6d74e91b372beb63f4fe7.jpg";